import React, { useState, useContext } from "react";

import { AuthContext } from "../../shared/context/auth-context";
import { useForm } from "../../shared/hooks/formHook";
import { useHttpClient } from "../../shared/hooks/http-hook";

import WrapperContainer from "../../shared/components/UIElements/WrapperContainer";
import Input from "../../shared/components/FormElements/Input";
import Button from "../../shared/components/FormElements/Button";
import { VALIDATOR_REQUIRE } from "../../shared/Tools/validators";

import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadSpinner from "../../shared/components/UIElements/LoadingSpinner";

import "./Auth.scss";

const AuthenticateForm = () => {
  const auth = useContext(AuthContext);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const [formOverallState, inputHandler, setFormData] = useForm(
    {
      frmLogin: {
        value: "",
        isValid: false,
      },
      frmPassword: {
        value: "",
        isValid: false,
      },
    },
    false
  );

  const authSubmitHandler = async (event) => {
    event.preventDefault(); // pour arreter le process par defaut de submit

    if (isLoginMode) {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACK_URL + "user/login",
          "POST",
          JSON.stringify({
            login: formOverallState.inputs.frmLogin.value,
            password: formOverallState.inputs.frmPassword.value,
          }),
          {
            "Content-Type": "application/json",
          }
        );
        auth.login(
          responseData.userId,
          responseData.token,
          responseData.nickName
        );
      } catch (err) {
        console.log(`erreur : ${err.message}`);
      }
    } else {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACK_URL + "user/signup",
          "POST",
          JSON.stringify({
            nickName: formOverallState.inputs.frmNickName.value,
            login: formOverallState.inputs.frmLogin.value,
            password: formOverallState.inputs.frmPassword.value,
          }),
          {
            "Content-Type": "application/json",
          }
        );
        auth.login(
          responseData.userId,
          responseData.token,
          responseData.nickName
        );
      } catch (err) {
        console.log("erreur !");
      }
    }
  };

  const switchModeHandler = () => {
    if (!isLoginMode) {
      setFormData(
        {
          ...formOverallState.inputs,
          frmNickName: undefined,
        },
        formOverallState.inputs.frmLogin.isValid &&
          formOverallState.inputs.frmPassword.isValid
      );
    } else {
      setFormData(
        {
          ...formOverallState.inputs,
          frmNickName: {
            value: "",
            isValid: false,
          },
        },
        false
      );
    }

    setIsLoginMode((prevMode) => !prevMode);
  };

  let welcomeLabel = "INSCRIVEZ-VOUS en 5 SECONDES";
  if (isLoginMode) {
    welcomeLabel = "CONNECTEZ-VOUS";
  }
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <WrapperContainer className="authentication">
        {isLoading && <LoadSpinner asOverlay />}
        <div className="authentication-header">
          <Button inverse onClick={switchModeHandler}>
            Switch to {isLoginMode ? "SIGN UP" : "LOG IN"}
          </Button>
          <h3>{welcomeLabel} :</h3>
        </div>
        <hr />
        <form onSubmit={authSubmitHandler}>
          {!isLoginMode && (
            <Input
              id="frmNickName"
              appearance={Input.appearances.login}
              element="input"
              type="text"
              label="Pseudo: "
              validators={[VALIDATOR_REQUIRE()]}
              errorText="not valid motherFucking Bastard"
              onInput={inputHandler}
            />
          )}
          {!isLoginMode && <div>&nbsp;</div>}
          <Input
            id="frmLogin"
            appearance={Input.appearances.login}
            element="input"
            type="text"
            label="Login: "
            validators={[VALIDATOR_REQUIRE()]}
            errorText="not valid motherFucker"
            onInput={inputHandler}
          />
          <div>&nbsp;</div>
          <Input
            id="frmPassword"
            appearance={Input.appearances.login}
            element="input"
            type="password"
            label="Password: "
            validators={[VALIDATOR_REQUIRE()]}
            errorText="not valid cocksucker"
            onInput={inputHandler}
          />
          <button
            className="btn-login-signup"
            type="submit"
            disabled={!formOverallState.isValid}
          >
            {isLoginMode ? "LOG IN" : "SIGN UP"}
          </button>
        </form>
      </WrapperContainer>
    </React.Fragment>
  );
};

export default AuthenticateForm;
